/**
 * Composable that provides portal-specific terminology
 * Returns different labels based on whether the user is in employer or dealer portal
 */
export const usePortalTerminology = (routeArg?: ReturnType<typeof useRoute>) => {
    const authStore = useAuthStore();
    const route = routeArg ?? useRoute();

    const isDealerRoute = computed(() => {
        return route?.path?.includes('dealer') ?? false;
    })

    const isDealer = computed(() => {
        const user = authStore.getUser;
        return user?.PortalType === 'dealer';
    });

    const isDealerPortal = computed(() => {
        return (isDealer?.value && isDealerRoute?.value) || (isDealer.value || isDealerRoute.value)
    })

    const organisationLabel = computed(() => {
        return isDealerPortal?.value ? 'Dealership' : 'Organisation';
    });

    const organisationLowercase = computed(() => {
        return organisationLabel.value.toLowerCase();
    });

    const clientLabel = computed(() => {
        return isDealerPortal?.value ? 'Dealership' : 'Client';
    });

    const clientLowercase = computed(() => {
        return clientLabel.value.toLowerCase();
    });

    const costCentreLabel = computed(() => {
        return isDealerPortal?.value ? 'Department' : 'Cost Centres';
    });

    const getContextualLabel = (employerTerm: string, dealerTerm: string) => {
        return isDealerPortal?.value ? dealerTerm : employerTerm;
    };

    return {
        isDealer: readonly(isDealer),
        isDealerRoute: readonly(isDealerRoute),
        isDealerPortal: readonly(isDealerPortal),
        organisationLabel: readonly(organisationLabel),
        organisationLowercase: readonly(organisationLowercase),
        clientLabel: readonly(clientLabel),
        clientLowercase: readonly(clientLowercase),
        costCentreLabel: readonly(costCentreLabel),
        getContextualLabel,

        // Convenience computed properties for common phrases
        selectOrganisation: computed(() => `Select ${organisationLabel.value}`),
        changeOrganisation: computed(() => `Change ${organisationLabel.value}`),
        selectClient: computed(() => `Select ${clientLabel.value}`),
        selectCostCentre: computed(() => `Select ${costCentreLabel.value}`),
    };
};
